/** Engagement Center: Admin-Center, Mitteilungen, Benachrichtigungen, Kündigungsdialog, Registrierung. */
const engagementDE: Record<string, string> = {
  adminNavEngagement: 'Engagement Center',
  adminPurposeEngagement: 'Kunden verstehen, erreichen und zurückholen: Zustand, Nachrichten, Automationen, Wachstum, Bindung.',

  engCenterTitle: 'Engagement Center',
  engCenterSubtitle: 'Kunden verstehen, erreichen und zurück an den Schreibtisch holen, bevor Kandidaten verloren gehen',
  engTab_kunden: 'Kunden',
  engTab_nachrichten: 'Nachrichten',
  engTab_vorlagen: 'Vorlagen',
  engTab_automationen: 'Automationen',
  engTab_aktionen: 'Aktionen',
  engTab_wachstum: 'Wachstum',
  engTab_umsatz: 'Umsatz',
  engTab_bindung: 'Bindung',
  engTab_wirkung: 'Wirkung',
  engTab_einstellungen: 'Einstellungen',

  // Allgemein
  engAll: 'Alle',
  engClose: 'Schließen',
  engSave: 'Speichern',
  engSearch: 'Suchen',
  engEmpty: 'Noch keine Daten.',
  engErrorLoad: 'Abfrage fehlgeschlagen',
  engErrorNotAvailable: 'Dieser Endpunkt ist noch nicht verfügbar',
  engOfTotal: 'von {{total}}',
  engMonths_one: '{{count}} Monat',
  engMonths_other: '{{count}} Monate',
  engMonthsShort: '{{value}} Mon.',
  engComputedAt: 'Berechnet: {{at}}',

  // Kennzahl-Zustände (Fehlschlag ≠ Leere)
  engMetricNotConnected: 'noch nicht angebunden',
  engMetricFailed: 'Berechnung fehlgeschlagen',
  engMetricPending: 'wird noch berechnet',
  engMetricNoData: 'keine Daten',
  engMetricStatus_ok: 'aktuell',
  engMetricStatus_not_connected: 'noch nicht angebunden',
  engMetricStatus_failed: 'Berechnung fehlgeschlagen',
  engMetricStatus_pending: 'wird noch berechnet',

  // Zustände, Segmente, Risiko
  engState_healthy: 'Gesund',
  engState_no_pilot: 'Ohne Pilot',
  engState_blocked: 'Blockiert',
  engState_churn_risk: 'Abwanderung',
  engSegment_heavy: 'Heavy',
  engSegment_normal: 'Normal',
  engSegment_occasional: 'Gelegentlich',
  engSegment_inactive: 'Inaktiv',
  engRisk_stable: 'stabil',
  engRisk_watch: 'beobachten',
  engRisk_at_risk: 'gefährdet',

  // Kunden
  engOverviewStatus: 'Kennzahlen: {{status}}',
  engRollupRun: 'Abgleich jetzt ausführen',
  engKpiActiveUsers7d: 'Aktive Nutzer (7 Tage)',
  engKpiActiveUsersSub: '{{diff}} zur Vorwoche · von {{total}}',
  engKpiStickiness: 'Stickiness DAU/MAU',
  engKpiStickinessSub: 'B2B üblich: 25–35 %',
  engKpiAutopilot: 'Autopilot läuft',
  engKpiAutopilotSub: 'Mandanten mit laufender Kampagne',
  engKpiApprovals24h: 'Freigaben > 24 h',
  engKpiReplies48h: 'Antworten > 48 h offen',
  engTrendTitle: 'Aktive Nutzer pro Tag · 28 Tage',
  engTrendEmpty: 'Noch keine Tageswerte.',
  engTrendLegend: 'Linie: aktive Nutzer · ▲ Markierung: Release oder Sendung aus dem Center',
  engStatesTitle: 'Zustand der Mandanten',
  engTenantsTitle: 'Mandanten',
  engTenantsEmpty: 'Keine Mandanten für diesen Filter.',
  engFilterState: 'Zustand',
  engFilterRisk: 'Risiko',
  engColTenant: 'Mandant',
  engColUsers: 'Nutzer',
  engColSegments: 'Segmente',
  engColAutopilot: 'Autopilot',
  engColWaiting: 'Wartet auf Kunde',
  engColState: 'Zustand',
  engColRisk: 'Risiko',
  engColLastMessage: 'Letzte Nachricht von uns',
  engCampaignsCount_one: '{{count}} Kampagne',
  engCampaignsCount_other: '{{count}} Kampagnen',
  engApprovalsCount_one: '{{count}} Freigabe',
  engApprovalsCount_other: '{{count}} Freigaben',
  engRepliesCount_one: '{{count}} Antwort',
  engRepliesCount_other: '{{count}} Antworten',
  engTimelineTitle: 'Zeitstrahl · {{name}}',
  engTimelineEmpty: 'Keine Ereignisse in den letzten 30 Tagen.',
  engTimelineKind_user: 'Aktion eines Nutzers',
  engTimelineKind_autopilot: 'Autopilot',
  engTimelineKind_message: 'Nachricht von uns',
  engTimelineKind_incident: 'Störung',

  // Nachrichten
  engComposeTitle: 'Nachricht verfassen',
  engComposeModeTemplate: 'Mit Vorlage',
  engComposeModeFree: 'Frei, ohne Vorlage',
  engComposeTemplate: 'Vorlage',
  engComposeTitleField: 'Titel',
  engComposeBody: 'Text',
  engComposeCtaLabel: 'Knopf-Beschriftung',
  engComposeCtaUrl: 'Knopf-Ziel (Pfad in PAI)',
  engComposeTopicClass: 'Klasse',
  engComposeTopic: 'Anlass',
  engComposeTopicHelp: 'Erscheint im Verlauf; leer = Name der Vorlage bzw. Titel',
  engComposeChannels: 'Kanäle',
  engComposeAudience: 'Zielgruppe',
  engComposeDelivery: 'Zustellung',
  engComposeDeliveryWindow: 'Nächstes Zustellfenster, 9:30 Uhr',
  engComposeDeliveryImmediate: 'Sofort',
  engComposePreview: 'Vorschau aktualisieren',
  engComposeTest: 'Test an mich',
  engComposeTestAgain: 'Test erneut senden',
  engComposeTesting: 'Test wird gesendet …',
  engComposeTestOk: 'Test ist raus. Senden ist freigeschaltet, solange sich der Inhalt nicht ändert.',
  engComposeSend_one: 'An {{count}} Nutzer senden',
  engComposeSend_other: 'An {{count}} Nutzer senden',
  engComposeRequestApproval_one: 'Zur Freigabe vorlegen ({{count}} Nutzer)',
  engComposeRequestApproval_other: 'Zur Freigabe vorlegen ({{count}} Nutzer)',
  engComposeHintNeedsTest: 'Senden wird erst nach dem Test freigeschaltet (Pflicht ab {{limit}} Empfängern). Jede Änderung am Inhalt verlangt einen neuen Test.',
  engComposeBlocker_no_content: 'Erst Vorlage wählen oder Titel und Text eingeben.',
  engComposeBlocker_no_channel: 'Mindestens einen Kanal wählen.',
  engComposeBlocker_no_estimate: 'Zielgruppe wird noch geschätzt.',
  engComposeBlocker_no_recipients: 'Die Zielgruppe ist leer.',
  engComposeBlocker_needs_test: 'Erst „Test an mich“.',
  engComposeApprovalHint: 'An alle oder mehr als 500 Empfänger: Ein zweiter Admin muss die Sendung freigeben.',
  engComposeError409: 'Die API verlangt zuerst einen Test mit genau diesem Inhalt.',
  engComposeErrorGeneric: 'Das hat nicht geklappt',
  engEstimateLoading: 'Zielgruppe wird geschätzt …',
  engEstimateFailed: 'Schätzung fehlgeschlagen. Ohne Schätzung bleibt Senden gesperrt.',
  engEstimateText: 'Schätzung: {{targeted}} Nutzer · {{withEmail}} mit E-Mail',
  engEstimateExcluded_one: '{{count}} ausgeschlossen ({{reason}})',
  engEstimateExcluded_other: '{{count}} ausgeschlossen ({{reason}})',
  engSendResult_scheduled: 'Eingeplant.',
  engSendResult_running: 'Wird gesendet.',
  engSendResult_completed: 'Gesendet.',
  engSendResult_completed_disabled: 'Verbucht, aber nicht zugestellt: Der Versand an Kunden ist ausgeschaltet. Im Verlauf steht die Sendung als übersprungen.',
  engSendResult_failed: 'Fehlgeschlagen.',
  engSendResult_awaiting_approval: 'Vorgelegt: Ein zweiter Admin muss freigeben.',
  engSendResult_dry_run: 'Probelauf, nichts gesendet.',
  engPreviewTitle: 'Vorschau',
  engPreviewEmpty: 'Noch keine Vorschau. „Vorschau aktualisieren“ rendert jeden gewählten Kanal.',
  engPreviewFor: 'Vorschau für {{user}}',
  engPreviewMissing: 'Fehlende Variablen: {{vars}}',
  engPreviewEmailSubject: 'E-Mail · Betreff',
  engPreviewVarsNote: 'Feste Variablen kommen aus der Datenbank, nicht aus der KI. Die KI formuliert nur den Satz drumherum.',
  engAudienceKind: 'Empfänger',
  engAudienceKind_all: 'Alle Nutzer',
  engAudienceKind_tenants: 'Mandanten',
  engAudienceKind_users: 'Einzelne Nutzer',
  engAudienceKind_state: 'Nach Zustand',
  engAudienceKind_segment: 'Nach Segment',
  engAudienceKind_trial: 'Testkunden',
  engAudienceTenants: 'Mandanten wählen',
  engAudienceUserIds: 'Nutzer-IDs',
  engAudienceUserIdsHelp: 'Durch Komma oder Leerzeichen getrennt',
  engAudienceTrialFrom: 'ab Testtag',
  engAudienceTrialTo: 'bis Testtag',
  engAudienceMinReplies: 'mind. Antworten',
  engAudienceRequireConsent: 'Nur mit Werbe-Einwilligung (Pflicht für Angebote per E-Mail)',
  engChannel_notification: 'Mitteilung in PAI',
  engChannel_email: 'E-Mail',
  engChannel_banner: 'Banner beim Login',
  engTopicClass_transactional: 'Transaktional',
  engTopicClass_product: 'Produkt',
  engTopicClass_offer: 'Angebot',
  engTopicClass_news: 'Neuigkeiten',
  engOutboxTitle: 'Versendete Nachrichten',
  engOutboxEmpty: 'Noch keine Sendungen.',
  engOutboxSource: 'Herkunft',
  engOutboxSource_all: 'Alle (ohne Tests)',
  engOutboxSource_automation: 'Automatik',
  engOutboxSource_system: 'System (Kontomails, Tagesbericht …)',
  engOutboxSource_manual: 'Admin',
  engOutboxSource_test: 'Tests',
  engColDate: 'Datum',
  engColTopic: 'Anlass',
  engColFrom: 'Von',
  engColChannels: 'Kanäle',
  engColChannel: 'Kanal',
  engColTargeted: 'adressiert',
  engColDelivered: 'zugestellt',
  engColOpened: 'geöffnet',
  engColReturned: 'zurückgekehrt',
  engColCompleted: 'erledigt',
  engColSkipped: 'übersprungen',
  engColStatus: 'Status',
  engColRecipient: 'Empfänger',
  engColSentAt: 'gesendet',
  engSourceAutomation: 'Automation {{key}}',
  engSourceSystem: 'System',
  engSourceViaUi: '{{name}} in der Oberfläche',
  engSourceViaMcp: '{{name}} über MCP',
  engSourceType_manual: 'manuell',
  engSourceType_test: 'Test',
  engStatus_scheduled: 'eingeplant',
  engStatus_running: 'läuft',
  engStatus_completed: 'abgeschlossen',
  engStatus_failed: 'fehlgeschlagen',
  engStatus_awaiting_approval: 'wartet auf Freigabe',
  engStatus_dry_run: 'Probelauf',
  engApprove: 'Freigeben',
  engApproveOwnHint: 'Freigeben muss ein anderer Admin als der Auftraggeber.',
  engMessageDetail: 'Sendung',
  engArtifacts: 'Nachweise (so wie die E-Mail rausging)',
  engKillSwitch: 'Not-Aus ausgelöst am {{at}}: {{reason}}',
  engKillSwitchShort: 'Not-Aus',
  engSkip_skipped_disabled: 'Versand ausgeschaltet',
  engSkip_disabled: 'Versand ausgeschaltet',
  engSkip_skipped_preference: 'abbestellt',
  engSkip_preference: 'abbestellt',
  engSkip_skipped_capped: 'Budget erreicht',
  engSkip_capped: 'Budget erreicht',
  engSkip_skipped_cooldown: 'Abstand 48 h',
  engSkip_cooldown: 'Abstand 48 h',
  engSkip_skipped_sunset: 'reagiert nicht mehr',
  engSkip_sunset: 'reagiert nicht mehr',
  engSkip_skipped_read: 'schon gelesen',
  engSkip_read: 'schon gelesen',
  engSkip_skipped_resolved: 'Anlass erledigt',
  engSkip_resolved: 'Anlass erledigt',
  engSkip_skipped_suppressed: 'Adresse gesperrt',
  engSkip_suppressed: 'Adresse gesperrt',
  engSkip_skipped_no_consent: 'ohne Einwilligung',
  engSkip_no_consent: 'ohne Einwilligung',
  engSkip_skipped_control: 'Kontrollgruppe',
  engSkip_control: 'Kontrollgruppe',
  engSkip_no_email: 'ohne E-Mail',
  engDeliveryStatus_pending_window: 'wartet auf Zustellfenster',
  engDeliveryStatus_sent: 'gesendet',
  engDeliveryStatus_failed: 'fehlgeschlagen',
  engDeliveryStatus_bounced: 'unzustellbar',
  engDeliveryStatus_skipped_disabled: 'übersprungen: Versand aus',
  engDeliveryStatus_skipped_preference: 'übersprungen: abbestellt',
  engDeliveryStatus_skipped_capped: 'übersprungen: Budget',
  engDeliveryStatus_skipped_cooldown: 'übersprungen: Abstand',
  engDeliveryStatus_skipped_sunset: 'übersprungen: reagiert nicht',
  engDeliveryStatus_skipped_read: 'übersprungen: gelesen',
  engDeliveryStatus_skipped_resolved: 'übersprungen: erledigt',
  engDeliveryStatus_skipped_suppressed: 'übersprungen: gesperrt',
  engDeliveryStatus_skipped_no_consent: 'übersprungen: keine Einwilligung',
  engDeliveryStatus_skipped_control: 'übersprungen: Kontrollgruppe',
  engBannerSendOff: 'Versand an Kunden ist ausgeschaltet (ENGAGEMENT_SEND_ENABLED). Nur Tests an Plattform-Admins werden zugestellt, alles andere landet als „übersprungen: Versand aus“ im Verlauf.',
  engBannerAutomationsOff: 'Automationen senden nicht (ENGAGEMENT_AUTOMATIONS_ENABLED aus). Sie berechnen ihre Zielgruppe und protokollieren nur, was sie senden würden.',
  engBannerDerived: '(abgeleitet aus den Zahlen der API)',

  // Vorlagen
  engTemplatesTitle: 'Vorlagen',
  engTemplatesEmpty: 'Noch keine Vorlagen.',
  engTemplateNew: 'Neue Vorlage',
  engTemplatePick: 'Vorlage links wählen oder neu anlegen.',
  engTemplateEditTitle: '{{name}} · {{lang}} · {{channel}}',
  engTemplateKey: 'Schlüssel',
  engTemplateName: 'Name',
  engTemplateActive: 'aktiv',
  engTemplateActivateNeedsTest: 'Aktivieren geht erst nach einem Test.',
  engTemplateTitle: 'Titel',
  engTemplateSubject: 'Betreff',
  engTemplateBody: 'Text',
  engTemplateBenefit: 'Nutzen für den Empfänger (Pflicht)',
  engTemplateBenefitHelp: 'Ein Satz: Was hat der Kunde davon, diese Nachricht zu bekommen?',
  engTemplateVariables: 'Variablen',
  engTemplateAddVariable: 'Variable',
  engTemplateVarName: 'Variable',
  engTemplateVarSource: 'Quelle',
  engTemplateVarDetail: 'Pfad / Anweisung',
  engTemplateVarsNote: 'Fest = aus der Datenbank. KI formuliert nur, erfindet nichts. Manuell = beim Senden ausfüllen.',
  engVarSource_deterministic: 'fest',
  engVarSource_manual: 'manuell',
  engVarSource_llm: 'KI',
  engVarLlmPlaceholder: 'z. B. ein freundlicher Satz, der zum Antworten einlädt',
  engVarManualHint: 'wird beim Verfassen ausgefüllt',
  engTemplateSystem: 'System',
  engTemplateStatus_active: 'aktiv',
  engTemplateStatus_inactive: 'inaktiv',
  engTemplateStatus_untested: 'Test fehlt',
  engTemplateSaved: 'Vorlage gespeichert.',
  engTemplateTestSent: 'Test ging an dich.',
  engTemplateLastTested: 'Zuletzt getestet: {{at}}',
  engTemplateNeverTested: 'Noch nie getestet',

  // Automationen
  engAutomationsTitle: 'Automationen',
  engAutomationsIntro: 'Jede Automation ist Auslöser + Bedingung + Vorlage. Pro Nutzer läuft höchstens ein Anlass gleichzeitig, die Reihenfolge der Liste ist die Priorität.',
  engAutomationsEmpty: 'Keine Automationen angelegt.',
  engColAutomation: 'Anlass',
  engColTrigger: 'Auslöser',
  engColLastRun: 'Letzter Lauf',
  engColEvaluated: 'geprüft',
  engColSent: 'gesendet',
  engColWouldSend: 'würde senden',
  engColEnabled: 'an',
  engWouldSendValue_one: 'würde {{count}} senden',
  engWouldSendValue_other: 'würde {{count}} senden',
  engNeverRun: 'noch nie',
  engDryRun: 'Probelauf',
  engDryRunTitle: 'Probelauf {{key}}',
  engDryRunCount_one: '{{count}} Empfänger würde die Nachricht bekommen.',
  engDryRunCount_other: '{{count}} Empfänger würden die Nachricht bekommen.',
  engDryRunNote: 'Nichts wurde gesendet.',

  // Aktionen
  engPromoNew: 'Neue Aktion',
  engPromoName: 'Name',
  engPromoDiscount: 'Rabatt',
  engPromoDiscountLabel: '{{percent}} % auf {{months}} Monate',
  engPromoCustom: 'Eigene Werte',
  engPromoPercent: 'Rabatt in %',
  engPromoMonths: 'Monate',
  engPromoAudience: 'Wer bekommt sie',
  engPromoEndsAfter: 'Gültig (Tage nach Zustellung)',
  engPromoEndsAfterHelp: 'Echte Frist, wird nicht verlängert',
  engPromoMaxRedemptions: 'höchstens Einlösungen',
  engPromoControl: 'Kontrollgruppe in %',
  engPromoControlHelp: 'bekommen bewusst keinen Rabatt',
  engPromoStripeNote: 'Stripe-Gutschein wird beim Bestätigen angelegt: einmal pro Mandant, nur Neukunden, Ablaufdatum gesetzt.',
  engPromoPreview: 'Vorschau',
  engPromoConfirm: 'Anlegen bestätigen',
  engPromoPreviewTitle: 'Vorschau',
  engPromoPreviewNothingCreated: 'Noch nichts angelegt.',
  engPromoPreviewStale: 'Geändert seit der Vorschau: Bitte neue Vorschau erstellen.',
  engPromoControlSize_one: 'Kontrollgruppe: {{count}} Empfänger',
  engPromoControlSize_other: 'Kontrollgruppe: {{count}} Empfänger',
  engPromoCreated: 'Aktion angelegt.',
  engPromoList: 'Laufende und vergangene Aktionen',
  engPromoEmpty: 'Noch keine Aktionen.',
  engPromoRedeemed: 'eingelöst',
  engPromoRevenue: 'Umsatz',
  engPromoEnd: 'Beenden',
  engPromoCap_one: 'max. {{count}} Einlösung',
  engPromoCap_other: 'max. {{count}} Einlösungen',
  engPromoStatus_draft: 'Entwurf',
  engPromoStatus_running: 'läuft',
  engPromoStatus_ended: 'beendet',
  engPromoControlRow: 'Ohne Aktion (Vergleich)',
  engPromoControlGroup: 'Kontrollgruppe',
  engPromoControlNote: 'Ein Teil der Empfänger bekommt bewusst keinen Rabatt. Nur so sieht man, ob der Rabatt Käufe bringt oder nur Umsatz kostet, der ohnehin gekommen wäre.',

  // Wachstum
  engKpiRegistrations: 'Registrierungen (30 T.)',
  engKpiActivated: 'Aktiviert',
  engKpiActivatedSub: 'LinkedIn verbunden + Kampagne',
  engKpiFirstReply: 'Erste Antwort erlebt',
  engKpiFirstReplySub: 'der Registrierten',
  engKpiTrialToPurchase: 'Test → Kauf',
  engKpiPurchasesCount_one: '{{count}} Kauf',
  engKpiPurchasesCount_other: '{{count}} Käufe',
  engKpiCostPerCustomer: 'Kosten pro Kunde',
  engKpiCostPerCustomerSub: 'Werbung + feste IPs der Testkonten',
  engFunnelTitle: 'Kanäle bis zum Kauf',
  engFunnelEmpty: 'Noch keine Registrierungen im Zeitraum.',
  engColSource: 'Kanal',
  engColSpend: 'Ausgaben',
  engColRegistrations: 'Registr.',
  engColActivated: 'aktiviert',
  engColFirstReply: '1. Antwort',
  engColPurchases: 'Käufe',
  engColCostPerCustomer: '€ / Kunde',
  engSourceDirect: 'Ohne Anzeige (direkt, Empfehlung)',
  engSourceUnattributed: 'nicht zugeordnet',
  engControlSumOk: 'Kontrolle bestanden: Kanäle + ohne Anzeige + nicht zugeordnet = Stripe-Umsatz.',
  engControlSumNotOk: 'Kontrolle nicht bestanden: Die Summe weicht vom Stripe-Umsatz ab, die Zahlen sind nicht belastbar.',
  engTrialFunnelTitle: 'Testmonat · wo die {{count}} Registrierten stehen',
  engTrialPipeline: 'Testkunden',
  engTrialEmpty: 'Keine Testkunden für diesen Filter.',
  engColTrialDay: 'Tag',
  engColReplies: 'Antworten',
  engColConsent: 'Werbe-Einwilligung',
  engExperimentsTitle: 'Website-Tests',
  engExperimentsEmpty: 'Keine laufenden Tests.',
  engColExperiment: 'Test · Variante',
  engColViews: 'Aufrufe',
  engColCtaRate: 'Klick „Registrieren“',
  engColDecision: 'Stand',
  engExpUndecided: 'noch nicht entscheidbar',
  engExpProgress: 'Tag {{day}} · {{share}} der nötigen Besucher',
  engExpWinner: '{{variant}} gewinnt · {{probability}} Wahrscheinlichkeit',
  engExpLoser: 'verliert',
  engExpNote: 'Bewertet wird bis zum Kauf. Vor genug Besuchern zeigt das Center „noch nicht entscheidbar“ statt eines frühen Siegers.',

  // Umsatz
  engKpiAdSpend: 'Werbeausgaben (30 T.)',
  engKpiAdSpendSub: 'Google + Meta',
  engKpiRevenueFromAds: 'Umsatz daraus bisher',
  engKpiRoasTarget: 'Ziel nach 12 Monaten: ≥ 4',
  engRoasTitle: 'Anzeigenkampagnen',
  engRoasEmpty: 'Noch keine Anzeigenkampagnen.',
  engRoasNote: 'ROAS = Umsatz ÷ Werbeausgaben. Kunden ohne Herkunft stehen als „nicht zugeordnet“ und werden keinem Kanal zugeschlagen.',
  engColAdCampaign: 'Anzeigenkampagne',
  engColRevenueToDate: 'Umsatz bisher',
  engColRoasToDate: 'ROAS bisher',
  engColRoas12m: 'ROAS 12 M.',
  engColPayback: 'Amortisation',

  // Bindung
  engKpiPaying: 'Zahlende Mandanten',
  engKpiMrr: 'Monatlicher Umsatz',
  engKpiMrrSub: 'wiederkehrend',
  engKpiChurn: 'Kündigungsrate',
  engKpiNrr: 'Umsatz-Bindung',
  engKpiAtRisk: 'Gefährdet',
  engKpiAtRiskSub: '{{mrr}} monatlich',
  engAtRiskTitle: 'Zahlende Kunden mit Risiko',
  engAtRiskEmpty: 'Kein zahlender Kunde mit Risiko.',
  engColMrr: '€ / Monat',
  engColReasons: 'Gründe',
  engCohortsTitle: 'Anteil noch zahlender Kunden nach Startmonat',
  engCohortsEmpty: 'Noch keine Kohorten.',
  engCohortsNote: 'Jede Zeile ist ein Startmonat, jede Spalte ein Monat danach. Leere Felder liegen in der Zukunft.',
  engReactivationTitle: 'Reaktivierung · Ehemalige',
  engReactivation_formerTenants: 'Ehemalige Kunden',
  engReactivation_formerContacted: 'davon angeschrieben (Rückkehrleiter)',
  engReactivation_reactivated: 'zurückgekehrt',
  engReactivation_cancelIntents: 'Kündigungsabsichten (12 Monate)',
  engReactivation_paused: 'pausiert statt gekündigt',
  engReactivation_downgraded: 'kleinerer Tarif statt gekündigt',
  engReactivation_reviewRequested: 'Kampagnenprüfung angefragt',
  engReactivation_kept: 'geblieben',
  engReactivation_cancelled: 'gekündigt',
  engChurnReasonsTitle: 'Kündigungsgründe',
  engChurnReasonsEmpty: 'Noch keine Kündigungsgründe erfasst.',

  // Wirkung
  engKpiUnsubscribeRate: 'Abmelderate E-Mail',
  engKpiLowTouch: 'Wenig-Kontakt-Nutzer',
  engKpiLowTouchSub: 'nur noch Mitteilungen und Konto-Mails',
  engKpiKillSwitch: 'Not-Aus ausgelöst',
  engInsightsFunnel: 'Funnel · alle Sendungen, 30 Tage',
  engInsightsCompletedNote: '„Erledigt“ heißt: der Anlass ist weg, also Freigabe erteilt, Antwort geschrieben oder Konto entsperrt. Diese Kennzahl zählt, nicht die Öffnungsrate.',
  engInsightsHistogram: 'Nicht-transaktionale Sendungen pro Nutzer und Woche',
  engInsightsSkips: 'Übersprungen nach Grund',
  engFunnelStep_targeted: 'adressiert',
  engFunnelStep_sent: 'gesendet',
  engFunnelStep_delivered: 'zugestellt',
  engFunnelStep_opened: 'geöffnet',
  engFunnelStep_clicked: 'geklickt',
  engFunnelStep_returned: 'zurückgekehrt',
  engFunnelStep_completed: 'erledigt',

  // Einstellungen
  engSettingsSwitches: 'Schalter',
  engSwitchSend: 'Versand an Kunden',
  engSwitchAutomations: 'Automationen senden',
  engSwitchOn: 'an',
  engSwitchOff: 'aus',
  engSwitchUnknown: 'unbekannt',
  engSettingsSwitchesNote: 'Die Schalter stehen in der Umgebung der API (ENGAGEMENT_SEND_ENABLED, ENGAGEMENT_AUTOMATIONS_ENABLED) und lassen sich hier nicht umlegen.',
  engSettingsTimeSaved: 'Zeitersparnis pro Handgriff (Minuten)',
  engSettingsTimeSavedNote: 'Diese Werte stehen in jeder Erfolgsbilanz offen dabei. Lieber vorsichtig rechnen.',
  engTimeProfileReview: 'Profil prüfen',
  engTimeConnectionRequest: 'Persönliche Anfrage',
  engTimeFollowUp: 'Folgenachricht',
  engTimeInmail: 'InMail',
  engSettingsCaps: 'Sendedisziplin',
  engSettingsCapsNote: 'Gilt für jeden Versandweg. Konto-Mails sind vom Budget ausgenommen.',
  engCapEmailPerDay: 'E-Mails pro Tag',
  engCapEmailPerWeek: 'E-Mails pro Woche',
  engCapNotificationPerDay: 'Mitteilungen pro Tag',
  engCapCooldownHours: 'Abstand zwischen Anlässen (h)',
  engSunsetAfter: 'weniger Kontakt nach ungeöffneten Sendungen',
  engSettingsSaved: 'Gespeichert.',

  // Kunde: Mitteilungen
  engNotifTitle: 'Mitteilungen',
  engNotifAriaUnread_one: 'Mitteilungen, {{count}} ungelesen',
  engNotifAriaUnread_other: 'Mitteilungen, {{count}} ungelesen',
  engNotifReadAll: 'Alle gelesen',
  engNotifMarkRead: 'Gelesen',
  engNotifEmpty: 'Keine Mitteilungen.',
  engNotifLoadFailed: 'Mitteilungen konnten nicht geladen werden.',
  engNotifShowAll: 'Alle Mitteilungen',
  engNotifPageSubtitle: 'Hinweise von PAI zu Ihren Kampagnen, Ihrem Konto und Neuigkeiten.',
  engNotifSettingsLink: 'Benachrichtigungen einstellen',

  // Kunde: Benachrichtigungen
  engPrefsTab: 'Benachrichtigungen',
  engPrefsSubtitle: 'Was Sie als Mitteilung in PAI und per E-Mail bekommen',
  engPrefsIntro: 'Legen Sie pro Art und Kanal fest, was Sie bekommen.',
  engPrefsFootnote: 'Konto und Sicherheit lässt sich nicht abschalten. Angebote per E-Mail gibt es nur mit Ihrer Einwilligung. Abgemeldet wird erst beim Speichern.',
  engPrefsSaved: 'Gespeichert.',
  engPrefsSaveFailed: 'Speichern fehlgeschlagen.',
  engPrefTopic_account: 'Konto und Sicherheit',
  engPrefTopicHint_account: '2FA, Captcha, Lizenz',
  engPrefTopic_campaigns: 'Kampagnen',
  engPrefTopicHint_campaigns: 'Antworten, Freigaben, leergelaufen',
  engPrefTopic_daily_report: 'Tagesbericht',
  engPrefTopicHint_daily_report: 'Zusammenfassung des Tages',
  engPrefTopic_news: 'Neuigkeiten',
  engPrefTopicHint_news: 'neue Funktionen, Tipps',
  engPrefTopic_offers: 'Angebote',
  engPrefTopicHint_offers: 'Rabatte und Aktionen',
  engPrefAccountLocked: 'Lässt sich nicht abschalten',
  engPrefOffersNeedConsent: 'Nur mit Einwilligung in Angebote per E-Mail',
  engConsentsTitle: 'Einwilligungen',
  engConsentsIntro: 'Beides ist freiwillig und jederzeit widerrufbar. Ein Widerruf gilt sofort.',
  engConsentMarketing: 'Angebote und Tipps per E-Mail erhalten',
  engConsentAdMeasurement:
    'Werbeerfolg messen und passende Werbung: Wir dürfen Google und Meta melden, wenn Sie sich über eine Anzeige registriert, Ihr Konto eingerichtet oder ein Abo abgeschlossen haben (mit Klick-Kennung, an Meta auch mit verschlüsselter E-Mail-Adresse). Beide dürfen Ihnen und ähnlichen Personen dann passende Werbung von uns zeigen.',
  engConsentSince: 'erteilt am {{at}}',
  engConsentWithdrawnAt: 'widerrufen am {{at}}',
  engConsentSaveFailed: 'Einwilligung konnte nicht gespeichert werden.',
  engConsentsLoadFailed: 'Einwilligungen konnten nicht geladen werden.',

  // Kunde: Kündigen
  engCancelButton: 'Kündigen',
  engCancelTitle: 'Ihre Zeit mit SAIA',
  engCancelTitleMonths_one: 'Ihr {{count}} Monat mit SAIA',
  engCancelTitleMonths_other: 'Ihre {{count}} Monate mit SAIA',
  engCancelResultsFailed: 'Ihre Bilanz konnte gerade nicht geladen werden. Kündigen geht trotzdem.',
  engResultConversations: 'Gespräche',
  engResultReplies: 'Antworten',
  engResultHoursSaved: 'gespart',
  engCancelWhy: 'Warum möchten Sie kündigen?',
  engCancelReason_role_filled: 'Stelle ist besetzt',
  engCancelReason_too_expensive: 'Zu teuer',
  engCancelReason_no_results: 'Zu wenig Ergebnisse',
  engCancelReason_other: 'Anderer Grund',
  engCancelComment: 'Was hat gefehlt? (freiwillig)',
  engCancelPauseMonths: 'Pausieren für',
  engCancelPauseButton_one: '{{count}} Monat pausieren',
  engCancelPauseButton_other: '{{count}} Monate pausieren',
  engCancelDowngradeButton: 'Kleineren Tarif ansehen',
  engCancelReviewButton: 'Kampagnen-Check mit SAIA',
  engCancelPaused_one: 'Pausiert für {{count}} Monat. Es wird nichts berechnet, Kontakte und Kampagnen bleiben gespeichert.',
  engCancelPaused_other: 'Pausiert für {{count}} Monate. Es wird nichts berechnet, Kontakte und Kampagnen bleiben gespeichert.',
  engCancelPauseFailed: 'Pausieren hat nicht geklappt. Bitte später erneut versuchen.',

  // Registrierung (Wortlaut: juristische Prüfung ausstehend)
  engSignupConsentMarketing: 'Ich möchte Angebote und Tipps per E-Mail erhalten (jederzeit widerrufbar)',
  engSignupConsentAdMeasurement:
    'Werbeerfolg messen und passende Werbung: Google und Meta dürfen erfahren, ob ich mich über eine Anzeige registriert, mein Konto eingerichtet oder ein Abo abgeschlossen habe (mit Klick-Kennung, an Meta auch mit verschlüsselter E-Mail-Adresse), und mir und ähnlichen Personen passende Werbung zeigen. Jederzeit widerrufbar, Details in der Datenschutzerklärung.',
  engAtRiskPartial: 'Kundenzustand {{status}}: nur Kündigungen und offene Zahlungen berücksichtigt.',
  engDryRunStatus_would_send: 'würde senden',
  engDryRunStatus_sent: 'gesendet',
  engDryRunStatus_already_sent: 'schon erhalten',
  engDryRunStatus_lower_priority: 'andere Automation hat Vorrang',
  engDryRunStatus_control_group: 'Kontrollgruppe',
  engDryRunStatus_failed: 'fehlgeschlagen',
  engTrialStage_registered: 'registriert',
  engTrialStage_trial: 'im Test',
  engTrialStage_activated: 'aktiviert',
  engTrialStage_first_reply: 'erste Antwort',
  engTrialStage_trial_expired: 'Test abgelaufen',
  engSkip_missing_variable: 'Variable ohne Wert',
  engSkip_skipped_missing_variable: 'Variable ohne Wert',
  engSkip_inactive_user: 'Nutzer inaktiv',
  engSkip_min_replies: 'zu wenige Antworten',
  engSkip_results_not_connected: 'Ergebnisse nicht angebunden',
  engSkip_results_failed: 'Ergebnisse nicht berechenbar',
  engDeliveryStatus_skipped_missing_variable: 'übersprungen: Variable ohne Wert',
  engStatus_rejected: 'abgelehnt',
  engSendResult_rejected: 'Abgelehnt.',
};

export default engagementDE;
